import { Seo, Eyebrow, ArrowLink } from "@/components/site/primitives";
import { Reveal } from "@/components/site/motion";
import { PageHero, Section } from "@/components/site/pageparts";
import { COMPANY } from "@/data/site";

export default function Patents() {
  return (
    <div data-testid="patents-page">
      <Seo title="Patents" description="DataFrontier has filed a patent application covering core methods in its intelligence infrastructure." />
      <PageHero
        eyebrow="Company · Patents"
        title="Filed, pending, and disclosing nothing enabling."
        lead="Our patent activity complements — it does not replace — our open-source commitment."
      />

      <Section>
        <Reveal className="max-w-measure">
          <p className="font-serif text-xl leading-[1.6] text-bone/90 md:text-2xl">
            DataFrontier has filed a patent application covering core methods in its unified personal and enterprise
            intelligence infrastructure — including approaches to verifiable, locally-sovereign memory representation and
            retrieval.
          </p>
          <p className="mt-8 text-[17px] leading-relaxed text-mist">
            The application is currently pending. To protect the integrity of the process, we do not discuss claims,
            methods, or implementation details beyond what is published in our open-source releases.
          </p>
          <p className="mt-6 text-[17px] leading-relaxed text-mist">
            Patents complement, rather than replace, our open-source commitment. The UPII core remains MIT-licensed and
            inspectable — a memory layer earns trust only if you can read how it behaves.
          </p>

          <div className="mt-12 border border-white/10 bg-white/[0.015] p-8">
            <div className="grid gap-6 font-mono text-sm sm:grid-cols-2">
              <div>
                <div className="text-mist">Status</div>
                <div className="mt-1 text-bone">Pending</div>
              </div>
              <div>
                <div className="text-mist">Application details</div>
                <div className="mt-1 text-bone">[APPLICATION DETAILS ON FILE]</div>
              </div>
              <div>
                <div className="text-mist">Jurisdiction(s)</div>
                <div className="mt-1 text-bone">[APPLICATION DETAILS ON FILE]</div>
              </div>
              <div>
                <div className="text-mist">Filing date</div>
                <div className="mt-1 text-bone">[APPLICATION DETAILS ON FILE]</div>
              </div>
            </div>
          </div>

          <p className="mt-10 text-[15px] leading-relaxed text-mist">
            For intellectual-property correspondence, contact{" "}
            <a href={`mailto:${COMPANY.emails.legal}`} className="link-underline pb-0.5 text-bone">{COMPANY.emails.legal}</a>.
          </p>
          <div className="mt-8">
            <ArrowLink to="/legal/open-source">Read our open-source & license notice</ArrowLink>
          </div>
        </Reveal>
      </Section>
    </div>
  );
}
